import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell } from "../../components/layout";
import PrepJobRunsPage from "./ui/PrepJobRunsPage";

const DataPrepRuns = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <PageContentShell>
      <PrepJobRunsPage />
    </PageContentShell>
  </DashboardLayout>
);

export default DataPrepRuns;
